/*
  Lazare "Nagrada" funnel: one screen at a time.
  Live data only: categories are collections, sizes/counts come from Shopify collection filters,
  cards are the collection rendered through the Section Rendering API for the chosen size,
  the cart is /cart.js, the reward is an existing discount code applied through /discount/<code>.
*/
(function () {
  var root = document.querySelector('[data-lz-sef]');
  if (!root) return;
  var D = root.dataset;
  var LIMIT = parseInt(D.limit, 10) || 6;
  var MIX = D.mix === 'true', MAX_PER_MODEL = parseInt(D.maxPerModel, 10) || 2, POOL = parseInt(D.pool, 10) || 36;
  function modelOf(card) {
    var t = (card.dataset.title || '').trim();
    return t.split(' - ')[0].replace(/^lazare\S*\s*/i, '').trim().toLowerCase();
  }
  /* pick LIMIT cards at random from the top POOL of the ranked list, biased to the top,
     with at most MAX_PER_MODEL cards of the same model (other colours) */
  function mixPick(ranked) {
    var pool = ranked.slice(0, POOL), w = pool.map(function (_, i) { return 1 / Math.sqrt(i + 1); });
    var picked = [], count = {};
    while (picked.length < LIMIT && pool.length) {
      var total = 0, i; for (i = 0; i < w.length; i++) total += w[i];
      var r = Math.random() * total, idx = 0;
      for (idx = 0; idx < pool.length; idx++) { r -= w[idx]; if (r <= 0) break; }
      if (idx >= pool.length) idx = pool.length - 1;
      var card = pool[idx], m = modelOf(card);
      pool.splice(idx, 1); w.splice(idx, 1);
      if ((count[m] || 0) >= MAX_PER_MODEL) continue;
      count[m] = (count[m] || 0) + 1; picked.push(card);
    }
    if (picked.length < LIMIT) ranked.forEach(function (c) { if (picked.length < LIMIT && picked.indexOf(c) < 0) picked.push(c); });
    return picked;
  }
  var RANK = D.rank || 'best';
  var BADGE_QTY = parseInt(D.badgeQty, 10) || 3;
  var CODE = D.code || '';
  var CODE_AMT = parseInt(D.codeAmount, 10) || 0;
  var THRESH = parseInt(D.threshold, 10) || 0;
  var FMT = D.moneyFormat || '{{amount}} RSD';
  var SS = 'lzsef:';
  var TOTAL_STEPS = 4;

  var state = { screen: 1, colUrl: null, colLabel: '', groups: [], picked: {}, sizeLabel: '', cards: 0, opened: 0, rewarded: false, cart: null };
  try { state.rewarded = sessionStorage.getItem(SS + 'rewarded') === '1'; } catch (e) {}

  function q(sel, r) { return (r || root).querySelector(sel); }
  function qa(sel, r) { return Array.prototype.slice.call((r || root).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tpl(str, map) { return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return k in map ? map[k] : m; }); }
  function save(k, v) { try { sessionStorage.setItem(SS + k, v); } catch (e) {} }
  function track(ev, data) {
    try {
      var p = Object.assign({ event: 'lz_sef', action: ev }, data || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(p);
      document.dispatchEvent(new CustomEvent('lz:sef', { detail: p }));
    } catch (e) {}
  }
  function money(cents) {
    var v = (cents || 0) / 100;
    function num(n, dec, thou, dp) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + dp + parts[1] : parts[0];
    }
    var out = FMT;
    if (/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/.test(out)) out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, num(v, 0, '.', ','));
    else if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(out)) out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, num(v, 2, '.', ','));
    else if (/\{\{\s*amount_no_decimals\s*\}\}/.test(out)) out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/, num(v, 0, ',', '.'));
    else out = out.replace(/\{\{\s*amount\s*\}\}/, num(v, 2, ',', '.'));
    return out.replace(/([.,])00(?=\s|$)/, '').trim();
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function fetchText(url) { return fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }); }
  function pickedQuery() {
    var s = '';
    Object.keys(state.picked).forEach(function (k) { s += '&' + encodeURIComponent(k) + '=' + encodeURIComponent(state.picked[k]); });
    return s;
  }
  function sortFor(rank) {
    if (rank === 'new') return 'created-descending';
    if (rank === 'price') return 'price-ascending';
    return 'best-selling';
  }

  /* ---------------- sticky top bar ---------------- */
  var top = q('[data-top]');
  var hdr = document.querySelector('.custom-header-sticky');
  function headerH() { return (hdr && !hdr.classList.contains('is-hidden')) ? hdr.getBoundingClientRect().height : 0; }
  function setTop() { root.style.setProperty('--sef-top', Math.round(headerH() + 8) + 'px'); }
  if (hdr) new MutationObserver(setTop).observe(hdr, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', setTop, { passive: true });
  setTop();

  function renderTop() {
    qa('[data-dot]').forEach(function (d) {
      var n = parseInt(d.dataset.dot, 10);
      d.classList.toggle('is-done', n < state.screen);
      d.classList.toggle('is-current', n === state.screen);
    });
    var sl = q('[data-step-label]');
    if (sl) sl.textContent = tpl(D.stepText, { n: state.screen, total: TOTAL_STEPS });
    var tb = q('[data-top]'); if (tb) tb.classList.toggle('is-compact', state.screen === 4);
    var rs = q('[data-reward-status]'), rt = q('[data-reward-text]'), el = q('[data-ebook-link]');
    if (rs) rs.classList.toggle('is-active', state.rewarded);
    if (rt) rt.textContent = state.rewarded ? tpl(D.rewardActive, { amount: '-' + money(CODE_AMT) }) : D.rewardLocked;
    if (el) { el.hidden = !state.rewarded; if (state.rewarded) prefetchEbook(el.getAttribute('href')).catch(function () {}); }
    var total = state.cart ? state.cart.total_price : 0;
    var count = state.cart ? state.cart.item_count : 0;
    var cw = q('[data-cart-wrap]');
    if (cw) {
      cw.hidden = !(count > 0);
      var ct = q('[data-cart-text]'), pt = q('[data-progress-text]'), pb = q('[data-progress-bar]');
      if (ct) ct.textContent = tpl(D.cartText, { n: count, total: money(total) });
      var shipOpen = THRESH > 0 && total >= THRESH;
      if (pt) pt.textContent = THRESH > 0 ? (shipOpen ? D.shippingDone : tpl(D.shippingText, { amount: money(Math.max(0, THRESH - total)) })) : '';
      if (pb) pb.style.width = Math.min(100, THRESH ? (total / THRESH) * 100 : 0) + '%';
    }
  }
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { state.cart = c; renderTop(); syncHeaderCount(c); return c; }).catch(function () {});
  }
  function syncHeaderCount(c) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !c) return;
    var count = bubble.querySelector('.custom-header__cart-count');
    if (!count && c.item_count > 0) {
      count = document.createElement('span');
      count.className = 'custom-header__cart-count';
      count.setAttribute('aria-hidden', 'true');
      bubble.appendChild(count);
    }
    if (count) {
      count.textContent = c.item_count;
      count.style.display = c.item_count > 0 ? '' : 'none';
    }
  }

  /* ---------------- screens ---------------- */
  function persist() {
    save('flow', JSON.stringify({ screen: state.screen, colUrl: state.colUrl, colLabel: state.colLabel, picked: state.picked }));
  }
  function goTo(n) {
    state.screen = n;
    persist();
    qa('[data-screen]').forEach(function (s) { s.classList.toggle('is-active', parseInt(s.dataset.screen, 10) === n); });
    renderTop();
    var y = root.getBoundingClientRect().top + window.scrollY - headerH() - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    track('screen', { n: n });
  }
  root.addEventListener('click', function (e) {
    var g = e.target.closest('[data-go]');
    if (g) { e.preventDefault(); goTo(parseInt(g.dataset.go, 10)); }
  });

  /* ---------------- 2. category ---------------- */
  qa('[data-tile]').forEach(function (tile) {
    tile.addEventListener('click', function () {
      qa('[data-tile]').forEach(function (t) { t.classList.toggle('is-active', t === tile); });
      state.colUrl = tile.dataset.url;
      state.colLabel = tile.dataset.label || '';
      state.picked = {};
      state.groups = [];
      var ctx = q('[data-ctx]'); if (ctx) ctx.textContent = state.colLabel;
      q('[data-sizes]').innerHTML = '<p class="sef-loading">…</p>';
      goTo(3);
      loadSizes();
      track('category', { collection: state.colUrl });
    });
  });

  /* ---------------- 3. sizes ---------------- */
  function rankGroup(g) {
    var l = (g.label || '').toLowerCase();
    if (l.indexOf('irina') !== -1) return 2;
    if (l.indexOf('užina') !== -1 || l.indexOf('uzina') !== -1) return 3;
    return 1;
  }
  function hasStock(g) { return g.values.some(function (v) { return v.count > 0; }); }
  function loadSizes() {
    var url = state.colUrl + '?filter.v.availability=1' + pickedQuery() + '&section_id=' + encodeURIComponent(D.sizesSection);
    return fetchText(url).then(function (html) {
      var doc = parseHTML(html);
      var groups = [];
      qa('[data-sef-size-group]', doc).forEach(function (s) {
        try { var g = JSON.parse(s.textContent); if (g && g.values && g.values.length) groups.push(g); } catch (e) {}
      });
      groups.sort(function (a, b) { return rankGroup(a) - rankGroup(b); });
      state.groups = groups;
      renderSizes();
    }).catch(function () {
      q('[data-sizes]').innerHTML = '<p class="sef-loading">' + esc(D.emptyText) + '</p>';
    });
  }
  function renderSizes() {
    var wrap = q('[data-sizes]');
    wrap.innerHTML = '';
    var live = state.groups.filter(function (g) { return state.picked[g.param] || hasStock(g); });
    if (!live.length) { wrap.innerHTML = '<p class="sef-loading">' + esc(D.emptyText) + '</p>'; return; }
    var pendingShown = false;
    live.forEach(function (g) {
      var picked = state.picked[g.param];
      if (!picked && pendingShown) return;
      var box = document.createElement('div');
      box.className = 'sef-sizegroup' + (picked ? ' is-done' : '');
      var chips = g.values.map(function (v) {
        var on = picked === v.value;
        var off = !v.count && !on;
        return '<button type="button" class="sef-chip' + (on ? ' is-active' : '') + '" data-chip data-param="' + esc(g.param) + '" data-value="' + esc(v.value) + '" data-label="' + esc(v.label) + '"' + (off ? ' disabled' : '') + '><b>' + esc(v.label) + '</b><small>' + (v.count || 0) + '</small></button>';
      }).join('');
      box.innerHTML = '<div class="sef-sizegroup__label">' + esc(g.label) + '</div><div class="sef-chips">' + chips + '</div>';
      wrap.appendChild(box);
      if (!picked) pendingShown = true;
    });
    if (!pendingShown) {
      state.sizeLabel = live.filter(function (g) { return state.picked[g.param]; }).map(function (g) {
        var v = g.values.filter(function (x) { return x.value === state.picked[g.param]; })[0];
        return v ? v.label : state.picked[g.param];
      }).join(' / ');
      goTo(4);
      loadCards();
    }
  }
  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-chip]');
    if (!chip || chip.disabled) return;
    var cur = state.groups.findIndex(function (g) { return g.param === chip.dataset.param; });
    Object.keys(state.picked).forEach(function (k) {
      var idx = state.groups.findIndex(function (g) { return g.param === k; });
      if (idx > cur) delete state.picked[k];
    });
    state.picked[chip.dataset.param] = chip.dataset.value;
    track('size', { param: chip.dataset.param, value: chip.dataset.value });
    loadSizes();
  });

  /* ---------------- 4. cards ---------------- */
  function loadCards() {
    var cards = q('[data-cards]'), empty = q('[data-empty]');
    cards.innerHTML = '<p class="sef-loading">…</p>';
    cards.classList.toggle('is-locked', !state.rewarded);
    empty.hidden = true;
    state.opened = 0;
    var url = state.colUrl + '?filter.v.availability=1' + pickedQuery() + '&sort_by=' + sortFor(RANK) + '&section_id=' + encodeURIComponent(D.resultsSection);
    return fetchText(url).then(function (html) {
      var doc = parseHTML(html);
      var list = qa('[data-card]', doc);
      if (RANK === 'saving') list.sort(function (a, b) { return (+b.dataset.saving - +a.dataset.saving) || (+a.dataset.rank - +b.dataset.rank); });
      if (RANK === 'scarce') list.sort(function (a, b) { return (+a.dataset.qty - +b.dataset.qty) || (+a.dataset.rank - +b.dataset.rank); });
      list = MIX ? mixPick(list) : list.slice(0, LIMIT);
      state.cards = list.length;
      cards.innerHTML = '';
      var heading = q('[data-cards-heading]');
      if (heading) heading.textContent = tpl(D.cardsTitle, { n: list.length, size: state.sizeLabel });
      var subEl = q('[data-cards-sub]');
      if (subEl && D.cardsSubTpl) { subEl.dataset.orig = tpl(D.cardsSubTpl, { n: list.length }); subEl.textContent = subEl.dataset.orig; }
      var eyebrow = q('[data-reward-eyebrow]');
      if (eyebrow && D.rewardEyebrowTpl) eyebrow.textContent = tpl(D.rewardEyebrowTpl, { n: list.length });
      if (!list.length) { empty.textContent = D.emptyText; empty.hidden = false; q('[data-cards-progress-wrap]').hidden = true; return; }
      q('[data-cards-progress-wrap]').hidden = false;
      list.forEach(function (card, i) {
        var qty = parseInt(card.dataset.qty, 10);
        var isLast = !isNaN(qty) && qty > 0 && qty <= BADGE_QTY;
        card.classList.toggle('is-last', isLast);
        var badge = q('[data-badge]', card);
        if (badge) { badge.hidden = !isLast; badge.textContent = D.lastBadge; }
        var ql = q('[data-qty-label]', card);
        if (ql) { ql.textContent = !isNaN(qty) && qty > 0 ? tpl(D.qtyText, { n: qty, size: state.sizeLabel }) : ''; ql.classList.toggle('is-last', isLast); }
        var bl = q('[data-buy-label]', card);
        if (bl) bl.textContent = tpl(D.buyText, { size: state.sizeLabel });
        var dl = q('[data-details]', card);
        if (dl) dl.textContent = D.detailsText || '';
        var num = q('.sef-card__back-num', card);
        if (num) num.textContent = (i + 1) + ' / ' + list.length;
        if (i === 0) card.classList.add('is-hint');
        cards.appendChild(card);
      });
      renderProgress();
      track('cards', { count: list.length, size: state.sizeLabel, collection: state.colUrl });
    }).catch(function () {
      cards.innerHTML = '';
      empty.textContent = D.emptyText; empty.hidden = false;
    });
  }
  function renderProgress() {
    var wrap = q('[data-cards-progress-wrap]'), bar = q('[data-cards-bar]'), txt = q('[data-cards-progress-text]'), sub = q('[data-cards-sub]');
    var done = state.cards > 0 && state.opened >= state.cards;
    if (bar) bar.style.width = (state.cards ? (state.opened / state.cards) * 100 : 0) + '%';
    if (txt) txt.textContent = tpl(D.cardsProgress, { open: state.opened, n: state.cards });
    if (wrap) wrap.classList.toggle('is-done', done);
    if (sub) {
      if (!sub.dataset.orig) sub.dataset.orig = sub.textContent;
      sub.textContent = done ? D.cardsDone : sub.dataset.orig;
    }
  }
  root.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); addToCart(add); return; }
    if (e.target.closest('[data-details]')) return;
    var card = e.target.closest('[data-card]');
    if (!card) return;
    if (card.classList.contains('is-flipped')) return;
    e.preventDefault();
    card.classList.add('is-flipped');
    card.classList.remove('is-hint');
    state.opened++;
    var next = qa('[data-card]:not(.is-flipped)')[0];
    if (next) next.classList.add('is-hint');
    renderProgress();
    track('open_card', { handle: card.dataset.handle, n: state.opened });
    if (state.opened >= state.cards) {
      if (state.rewarded) { q('[data-cards]').classList.remove('is-locked'); }
      else setTimeout(openReward, 650);
    }
  });
  qa('[data-replay]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.picked = {}; state.colUrl = null; state.sizeLabel = '';
      qa('[data-tile]').forEach(function (t) { t.classList.remove('is-active'); });
      goTo(2);
      track('replay');
    });
  });

  /* ---------------- cart ---------------- */
  function addToCart(btn) {
    if (btn.disabled) return;
    var id = parseInt(btn.dataset.id, 10);
    if (!id) return;
    btn.disabled = true;
    var card = btn.closest('[data-card]');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.classList.add('is-added');
        var bl = q('[data-buy-label]', btn) || btn; bl.textContent = D.addedText;
        track('add_to_cart', { id: id, handle: card ? card.dataset.handle : '' });
        return fetchCart();
      })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function () { btn.disabled = false; });
  }

  /* ---------------- confetti ---------------- */
  function confetti(canvas, ms) {
    if (!canvas) return;
    var host = canvas.parentElement;
    var W = host.clientWidth, H = host.clientHeight;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = W * dpr; canvas.height = H * dpr;
    var ctx = canvas.getContext('2d'); ctx.scale(dpr, dpr);
    var colors = ['#b10f1a', '#c9a24a', '#ffffff', '#181818', '#e2c27a'];
    var parts = [];
    for (var i = 0; i < 140; i++) {
      parts.push({ x: W / 2 + (Math.random() - .5) * W * .5, y: H * .38, vx: (Math.random() - .5) * 14, vy: -6 - Math.random() * 11, g: .32 + Math.random() * .15, w: 5 + Math.random() * 5, h: 8 + Math.random() * 6, r: Math.random() * Math.PI, vr: (Math.random() - .5) * .3, c: colors[i % colors.length], a: 1 });
    }
    var start = performance.now();
    function frame(t) {
      var k = (t - start) / (ms || 1800);
      ctx.clearRect(0, 0, W, H);
      parts.forEach(function (p) {
        p.vy += p.g; p.x += p.vx; p.y += p.vy; p.vx *= .99; p.r += p.vr; p.a = Math.max(0, 1 - Math.max(0, k - .6) / .4);
        ctx.save(); ctx.globalAlpha = p.a; ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore();
      });
      if (k < 1) requestAnimationFrame(frame); else ctx.clearRect(0, 0, W, H);
    }
    requestAnimationFrame(frame);
  }

  /* ---------------- ebook: save on device, never leave the page ---------------- */
  var ebookPromise = null;
  function isInApp() { return /FBAN|FBAV|FB_IAB|FBIOS|Instagram|TikTok|musical_ly|Bytedance|Snapchat|Line\/|Twitter|Pinterest/i.test(navigator.userAgent || ''); }
  function prefetchEbook(url) {
    if (!url) return Promise.reject(new Error('nourl'));
    if (!ebookPromise) {
      ebookPromise = fetch(url, { mode: 'cors' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
        .catch(function (e) { ebookPromise = null; throw e; });
    }
    return ebookPromise;
  }
  function toast(msg) {
    var t = q('[data-toast]');
    if (!t || !msg) return;
    t.textContent = msg; t.hidden = false; t.classList.remove('is-in');
    void t.offsetWidth; t.classList.add('is-in');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('is-in'); t.hidden = true; }, 6000);
  }
  function saveViaAnchor(blob, name) {
    var o = URL.createObjectURL(blob);
    var a = document.createElement('a'); a.href = o; a.download = name; a.rel = 'noopener'; a.style.display = 'none';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(o); }, 60000);
    return 'download';
  }
  function saveBlob(blob, name) {
    var file = null;
    try { file = new File([blob], name, { type: 'application/pdf' }); } catch (e) {}
    var canShare = !!(file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] }));
    var hasDl = 'download' in HTMLAnchorElement.prototype;
    var preferShare = isInApp() || !hasDl;
    if (preferShare && canShare) {
      return navigator.share({ files: [file], title: name }).then(function () { return 'share'; }).catch(function (err) {
        if (err && err.name === 'AbortError') return 'cancel';
        if (hasDl) return saveViaAnchor(blob, name);
        throw err;
      });
    }
    if (hasDl) return Promise.resolve(saveViaAnchor(blob, name));
    if (canShare) return navigator.share({ files: [file], title: name }).then(function () { return 'share'; });
    return Promise.reject(new Error('unsupported'));
  }
  function downloadEbook(link) {
    var url = link.getAttribute('href');
    var name = link.getAttribute('download') || 'ebook.pdf';
    if (!url || link.classList.contains('is-busy')) return;
    var label = q('[data-ebook-label]', link) || link;
    var orig = label.textContent;
    link.classList.add('is-busy');
    label.textContent = D.ebookDownloading || orig;
    track('ebook_download', { inapp: isInApp() });
    prefetchEbook(url)
      .then(function (blob) { return saveBlob(blob, name); })
      .then(function (how) {
        link.classList.remove('is-busy'); label.textContent = orig;
        if (how !== 'cancel') { link.classList.add('is-done-dl'); if (D.ebookSaved) toast(D.ebookSaved); }
        track('ebook_saved', { how: how });
      })
      .catch(function () {
        link.classList.remove('is-busy'); label.textContent = orig;
        toast(D.ebookFail || '');
        track('ebook_fail', { inapp: isInApp() });
      });
  }
  root.addEventListener('click', function (e) {
    var l = e.target.closest('[data-ebook-dl]');
    if (!l) return;
    e.preventDefault();
    downloadEbook(l);
  });

  /* ---------------- reward ---------------- */
  var modal = q('[data-reward]');
  function openReward() {
    if (!modal) return;
    var field = q('[data-scratch-field]', modal);
    field.classList.remove('is-done');
    q('[data-reward-result]', modal).hidden = true;
    modal.hidden = false;
    document.body.classList.add('sef-modal-open');
    var pre = q('[data-ebook-dl]', modal); if (pre) prefetchEbook(pre.getAttribute('href')).catch(function () {});
    requestAnimationFrame(function () {
      initCanvas(field, function () {
        field.classList.add('is-done');
        q('[data-reward-result]', modal).hidden = false;
        var hint = q('[data-reward-hint]', modal); if (hint) hint.hidden = true;
        confetti(q('[data-confetti]', modal), 1900);
        applyReward();
      });
    });
    track('reward_open');
  }
  function initCanvas(field, onDone) {
    var c = q('canvas', field);
    var rect = field.getBoundingClientRect();
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    c.width = Math.max(1, Math.round(rect.width * dpr));
    c.height = Math.max(1, Math.round(rect.height * dpr));
    var ctx = c.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = '#9a9a9a';
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.fillStyle = '#b3b3b3';
    for (var y = 0; y < c.height; y += 14 * dpr) { ctx.fillRect(0, y, c.width, 4 * dpr); }
    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold ' + Math.round(15 * dpr) + 'px "LT Wave", sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText((D.rewardHintCanvas || 'PROTRLJAJ'), c.width / 2, c.height / 2);
    ctx.globalCompositeOperation = 'destination-out';
    var down = false, moves = 0, finished = false, started = 0;
    var MIN_MS = parseInt(D.scratchMs, 10) || 5000;
    var r = Math.max(11, Math.round(rect.width / 14)) * dpr;
    function pos(e) { var b = c.getBoundingClientRect(); return { x: (e.clientX - b.left) * (c.width / b.width), y: (e.clientY - b.top) * (c.height / b.height) }; }
    function dot(p) { ctx.beginPath(); ctx.arc(p.x, p.y, r, 0, Math.PI * 2); ctx.fill(); }
    function ratio() {
      var img = ctx.getImageData(0, 0, c.width, c.height).data, clear = 0, n = 0;
      for (var i = 3; i < img.length; i += 4 * 11) { n++; if (img[i] === 0) clear++; }
      return n ? clear / n : 0;
    }
    var timer = null;
    function cleanup() {
      ['pointerup', 'pointercancel', 'mouseup', 'touchend', 'touchcancel'].forEach(function (t) { window.removeEventListener(t, release); });
      if (timer) { clearInterval(timer); timer = null; }
    }
    function check() {
      if (finished) return;
      var rt = ratio(), elapsed = started ? Date.now() - started : 0;
      if (rt > 0.97 || (rt > 0.6 && elapsed >= MIN_MS)) { finished = true; cleanup(); onDone(); }
    }
    function release() { down = false; check(); }
    c.onpointerdown = function (e) { down = true; if (!started) started = Date.now(); try { if (c.setPointerCapture) c.setPointerCapture(e.pointerId); } catch (err) {} dot(pos(e)); e.preventDefault(); };
    c.onpointermove = function (e) { if (!down) return; dot(pos(e)); if (++moves % 3 === 0) check(); e.preventDefault(); };
    c.onpointerup = c.onpointercancel = release;
    ['pointerup', 'pointercancel', 'mouseup', 'touchend', 'touchcancel'].forEach(function (t) { window.addEventListener(t, release); });
    timer = setInterval(function () { if (moves > 0) check(); }, 500);
  }
  function applyReward() {
    if (state.rewarded) return;
    state.rewarded = true; save('rewarded', '1');
    if (CODE) fetch('/discount/' + encodeURIComponent(CODE) + '?redirect=%2F', { credentials: 'same-origin', redirect: 'follow' }).catch(function () {});
    var attrs = { 'Bonus': D.bonusAttr || CODE };
    function stamp() {
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (!c || !c.attributes || c.attributes.Bonus !== attrs.Bonus) throw new Error('attr'); });
    }
    stamp().catch(function () { setTimeout(function () { stamp().catch(function () {}); }, 1500); });
    q('[data-cards]').classList.remove('is-locked');
    renderProgress();
    renderTop();
    var rs = q('[data-reward-status]');
    if (rs) { rs.classList.add('is-fresh'); setTimeout(function () { rs.classList.remove('is-fresh'); }, 900); }
    try { if (navigator.vibrate) navigator.vibrate([30, 40, 60]); } catch (e) {}
    track('reward', { code: CODE });
  }
  function scrollToCards() {
    var h = q('[data-cards-heading]'), tb = q('[data-top]');
    if (!h) return;
    var stuck = parseFloat(getComputedStyle(root).getPropertyValue('--sef-top')) || 0;
    var off = stuck + (tb ? tb.offsetHeight : 0) + 12;
    var y = h.getBoundingClientRect().top + window.pageYOffset - off;
    try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); } catch (err) { window.scrollTo(0, Math.max(0, y)); }
  }
  if (modal) {
    modal.addEventListener('touchmove', function (e) {
      var panel = e.target.closest('.sef-modal__panel');
      if (!panel || panel.scrollHeight <= panel.clientHeight + 1) e.preventDefault();
    }, { passive: false });
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-reward-close]') || (modal && e.target === modal && q('[data-scratch-field]', modal).classList.contains('is-done'))) {
      if (modal) modal.hidden = true;
      document.body.classList.remove('sef-modal-open');
      scrollToCards();
    }
  });

  /* ---------------- animated headline ---------------- */
  function animateTitle() {
    var h = q('[data-title]');
    if (!h || h.dataset.done) return;
    h.dataset.done = '1';
    var text = h.textContent.replace(/\s+/g, ' ').trim();
    var hl = (h.dataset.highlight || '').trim();
    var html = '', idx = 0;
    function words(str) {
      return str.split(' ').filter(Boolean).map(function (w) { return '<span class="sef-w" style="--i:' + (idx++) + '">' + esc(w) + '</span>'; }).join(' ');
    }
    var pos = hl ? text.toLowerCase().indexOf(hl.toLowerCase()) : -1;
    if (pos >= 0) {
      var before = text.slice(0, pos), mid = text.slice(pos, pos + hl.length), after = text.slice(pos + hl.length);
      var tail = after.match(/^[.,!?]+/) ? after.match(/^[.,!?]+/)[0] : '';
      after = after.slice(tail.length);
      var startIdx = before.trim() ? before.trim().split(' ').length : 0;
      html = words(before) + (before.trim() ? ' ' : '') + '<span class="sef-hl" style="--i:' + startIdx + '">' + words(mid + tail) + '</span>' + (after.trim() ? ' ' + words(after) : '');
    } else {
      html = words(text);
    }
    h.innerHTML = html;
    requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('is-in'); }); });
  }

  /* ---------------- init (restore where the visitor stopped) ---------------- */
  var restored = null;
  try { restored = JSON.parse(sessionStorage.getItem(SS + 'flow') || 'null'); } catch (e) {}
  if (restored && restored.colUrl && restored.screen >= 3) {
    state.colUrl = restored.colUrl;
    state.colLabel = restored.colLabel || '';
    state.picked = restored.picked || {};
    qa('[data-tile]').forEach(function (t) { t.classList.toggle('is-active', t.dataset.url === state.colUrl); });
    var ctx0 = q('[data-ctx]'); if (ctx0) ctx0.textContent = state.colLabel;
    q('[data-sizes]').innerHTML = '<p class="sef-loading">…</p>';
    goTo(3);
    loadSizes();
  } else {
    goTo(1);
  }
  animateTitle();
  renderTop();
  fetchCart();
})();
